import { render, staticRenderFns } from "./DraftjsEditor.vue?vue&type=template&id=50b196bd"
import script from "./DraftjsEditor.vue?vue&type=script&lang=js"
export * from "./DraftjsEditor.vue?vue&type=script&lang=js"
import style0 from "./DraftjsEditor.vue?vue&type=style&index=0&id=50b196bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports